import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Select,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { AuthorizedLayout } from "../Layouts/AuthorizedLayout";
import Icon from "../../Assets/images/svg/Icons/receipt_FILL1_.svg";
import SearchandExport from "../../Components/Common/SearchandExport/SearchandExport";
import ActionIcon from "../../Assets/images/png/Action.png";
import { GridLegacy as Grid } from "@mui/material";
import "../../Components/Common/Styles/Formstyles.css";
import BoxHeader from "../../Components/Common/Box/Boxheader";
import { GetApiMethod, PostApiMethod, PatchApiMethod, DeleteApiMethod } from "../../Utils/ApiService";
import { useCategory, useSubcategories, useServices } from "../../Components/Common/Context/Context";

import { couponSchema } from "../../Components/Validation";

import { Formik, Form } from "formik";
interface CouponFormValues {
  code: string;
  title: string;
  description: string;
  discountType: string;
  discountValue: number | "";
  minOrderAmount: number | "";
  maxDiscountAmount: number | "";
  usageLimit: number | "";
  validFrom: string;
  validTo: string;
  isActive: boolean;
  category: string;
  subcategory: string;
  service: string;
}

const Coupon_Management = () => {
  const [loading, setLoading] = useState(false);
  const [showCouponList, setShowCouponList] = useState(true);
  const [editingCouponId, setEditingCouponId] = useState<string | null>(null);
  const [newCouponName, setNewCouponName] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [subcategory, setSubcategory] = useState<string>("");
  const [service, setService] = useState<string>("");
  const [, setTouched] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedCouponId, setSelectedCouponId] = useState<string | null>(null);
  const subcategories = useSubcategories(category);
  const [couponList, setCouponList] = useState<any[]>([]);
  const { allCategories } = useCategory();
  const services = useServices();
  //  const [code, setCode] = useState("");
  const [title,] = useState("");
  const [description,] = useState("");
  const [discountType,] = useState("");
  const [discountValue,] = useState<number | "">("");
  const [minOrderAmount,] = useState<number | "">("");
  const [maxDiscountAmount,] = useState<number | "">("");
  const [usageLimit,] = useState<number | "">("");
  const [validFrom,] = useState("");
  const [validTo,] = useState("");
  const [isActive,] = useState(true);


  // 🔹 Fetch Coupons
  const fetchCoupons = async () => {
    setLoading(true);
    try {
      const response = await GetApiMethod("/coupon/list"); // Axios returns response object
      const res = response?.data;

      if (res?.status === "success") {
        const records = res.data.records || [];

        const mappedRecords = records.map((coupon: any) => {
          let categories: string[] = [];
          let providers: string[] = [];

          try {
            categories = Array.isArray(coupon.applicableToCategories)
              ? coupon.applicableToCategories
              : JSON.parse(coupon.applicableToCategories || "[]");
          } catch (err) {
            console.warn("Failed to parse applicableToCategories for coupon", coupon.id, err);
          }

          try {
            providers = Array.isArray(coupon.applicableToProviders)
              ? coupon.applicableToProviders
              : JSON.parse(coupon.applicableToProviders || "[]");
          } catch (err) {
            console.warn("Failed to parse applicableToProviders for coupon", coupon.id, err);
          }

          return {
            ...coupon,
            categoryName: allCategories.find(cat => cat.id === categories[0])?.name || "",
            serviceName: services.find(srv => srv.id === providers[0])?.name || "",
          };
        });

        setCouponList(mappedRecords);
      } else {
        console.error("Failed to fetch coupons: API returned failure", res);
      }
    } catch (error: any) {
      console.error("Failed to fetch coupons:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };


  // useEffect(() => {
  //   fetchCoupons();
  // }, []);
  useEffect(() => {
    setSubcategory(""); // reset subcategory when category changes
  }, [category]);

  // Reset Form
  const resetForm = () => {
    setNewCouponName("");
    setCategory("");
    setSubcategory("");
    setService("");
    setTouched(false);
    setEditingCouponId(null);
  };

  // Create or Update Coupon
  const handleSubmit = async (values: CouponFormValues) => {
    const payload = {
      code: values.code,
      title: values.title,
      description: values.description,
      discountType: values.discountType,
      discountValue: values.discountValue,
      minOrderAmount: values.minOrderAmount,
      maxDiscountAmount: values.maxDiscountAmount,
      usageLimit: values.usageLimit,
      validFrom: values.validFrom,
      validTo: values.validTo,
      isActive: values.isActive,
      applicableToCategories: [values.category],
      applicableToProviders: values.service ? [values.service] : [],
    };

    try {
      if (editingCouponId) {
        await PatchApiMethod(`/coupon/${editingCouponId}`, payload);
      } else {
        await PostApiMethod("/coupon/create", payload);
      }
      fetchCoupons();
      resetForm();
      setShowCouponList(true);
    } catch (error) {
      console.error("Error saving coupon:", error);
    }
  };


  // Delete Coupon
  const handleDelete = async (id: string) => {
    try {
      await DeleteApiMethod(`/coupon/${id}`);
      fetchCoupons();
    } catch (error) {
      console.error("Error deleting coupon:", error);
    }
  };

  // Edit Coupon
  const handleEdit = async (id: string) => {
    try {
      const res: any = await GetApiMethod(`/coupon/${id}`);
      if (res?.status === "success") {
        const c = res.data;
        setEditingCouponId(c.id);
        setNewCouponName(c.code);
        setCategory(c.category);
        setSubcategory(c.subCategory);
        setService(c.service);
        setShowCouponList(false);
      }
    } catch (error) {
      console.error("Error fetching coupon:", error);
    }
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, couponId: string) => {
    setAnchorEl(event.currentTarget);
    setSelectedCouponId(couponId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedCouponId(null);
  };

  const filteredCoupons = couponList.filter((coupon) =>
    Object.values(coupon).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <AuthorizedLayout>
      <Card className="card-layout" variant="outlined" sx={{ mt: 3, p: 2 }}>
        {loading && (
          <Box className="loading-overlay">
            <CircularProgress size={50} thickness={5} />
          </Box>
        )}

        <BoxHeader
          dashboard_name="Coupon Management"
          image={Icon}
          button_show={true}
          button_name="New Coupon"
          onAdd={() => {
            resetForm();
            setShowCouponList(false);
          }}
          tabs={["All Coupons"]}

          onTabChange={(newTabIndex) => setShowCouponList(newTabIndex === 0)}
        />


        {!showCouponList ? (
          <Formik
            initialValues={{
              code: newCouponName,
              title,
              description,
              discountType,
              discountValue,
              minOrderAmount,
              maxDiscountAmount,
              usageLimit,
              validFrom,
              validTo,
              isActive,
              category,
              subcategory,
              service,
            }}
            validationSchema={couponSchema} // define Yup schema for validation
            onSubmit={handleSubmit}         // pass values directly
            enableReinitialize
          >
            {({ values, handleChange, handleBlur, errors, touched }) => (
              <Form id="coupon-form">
                <Typography className="form-header" mb={2}>
                  {editingCouponId ? "Edit Coupon" : "Add New Coupon"}
                </Typography>

                <Grid container spacing={3}>
                  {/* Coupon Code */}
                  <Grid item xs={12} md={4}>
                    <Typography className="form-input">Coupon Code</Typography>
                    <TextField
                      className="form-input"
                      fullWidth
                      variant="standard"
                      placeholder="Type here"
                      name="code"
                      value={values.code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.code && Boolean(errors.code)}
                      helperText={touched.code && errors.code}
                      inputProps={{ maxLength: 255 }}
                    />
                  </Grid>

                  {/* Category */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth variant="standard" className="form-input" error={touched.category && Boolean(errors.category)}>
                      <Typography className="form-input">Category</Typography>
                      <Select
                        name="category"
                        value={values.category}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="">Select Category</MenuItem>
                        {allCategories.filter((cat) => cat.status).map((cat) =>
                        (<MenuItem key={cat.id} value={cat.id}>
                          {cat.name}
                        </MenuItem>
                        ))}
                      </Select>
                      {touched.category && errors.category && (
                        <FormHelperText>{errors.category}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  {/* Subcategory */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth variant="standard" className="form-input" error={touched.subcategory && Boolean(errors.subcategory)}>
                      <Typography className="form-input">Subcategory</Typography>
                      <Select
                        name="subcategory"
                        value={values.subcategory}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="">Select Subcategory</MenuItem>
                        {subcategories.map((sub) => (
                          <MenuItem key={sub.id} value={sub.id}>
                            {sub.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.subcategory && errors.subcategory && (
                        <FormHelperText>{errors.subcategory}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Services */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth variant="standard" className="form-input" error={touched.service && Boolean(errors.service)}>
                      <Typography className="form-input">Services</Typography>
                      <Select
                        name="service"
                        value={values.service}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="">Select Service</MenuItem>
                        {services.map((srv) => (
                          <MenuItem key={srv.id} value={srv.id}>
                            {srv.name} {srv.price ? `- $${srv.price}` : ""}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.service && errors.service && (
                        <FormHelperText>{errors.service}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Box display="flex" gap={2} mt={3}>
                  <Button
                    onClick={() => {
                      resetForm();
                      setShowCouponList(true);
                    }}
                    className="btn-cancel"
                  >
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" className="btn-next">
                    {editingCouponId ? "Update" : "Add"}
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        ) : (
          <>
            <SearchandExport searchPlaceholder="Search coupon..." onSearchChange={setSearchQuery} />

            <Box>
              <Table className="table" sx={{ overflowX: "auto" }}>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-header">Coupon Code</TableCell>
                    <TableCell className="table-header">Category</TableCell>
                    <TableCell className="table-header">Subcategory</TableCell>
                    <TableCell className="table-header">Service</TableCell>
                    <TableCell className="table-header">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredCoupons.map((coupon) => (
                    <TableRow key={coupon.id}>
                      <TableCell>{coupon.code}</TableCell>
                      <TableCell>{coupon.categoryName}</TableCell>
                      <TableCell>{subcategories.find(sub => sub.id === coupon.subCategory)?.name || ""}</TableCell>
                      <TableCell>{coupon.serviceName}</TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Typography className="table-cell action">
                            Action
                          </Typography>
                          <IconButton onClick={(e) => handleOpenMenu(e, coupon.id)}>
                            <img src={ActionIcon} alt="action" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>

          </>
        )}

        {/* Action Menu */}
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
          <MenuItem
            onClick={() => {
              if (selectedCouponId) handleEdit(selectedCouponId);
              handleCloseMenu();
            }}
          >
            Edit
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (selectedCouponId) handleDelete(selectedCouponId);
              handleCloseMenu();
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </Card>
    </AuthorizedLayout>
  );
};

export default Coupon_Management;
